import { configure } from "mobx"

configure({
    enforceActions: "observed",
    computedRequiresReaction: false,
    reactionRequiresObservable: false,
    observableRequiresReaction: false,
})
